import {forwardRef} from '@chakra-ui/react';
import type {HTMLChakraProps} from '@chakra-ui/system';
import {ChakraDiv} from '@linx-security/ui/utils/chakra-elements';

import {useFormSectionStyleConfig} from '../../theme-config';

export const FormSection = forwardRef<HTMLChakraProps<'div'>, 'div'>((props, ref) => {
  const {container} = useFormSectionStyleConfig();
  return <ChakraDiv sx={container} {...props} ref={ref} />;
});

export const FormSectionHeader = forwardRef<HTMLChakraProps<'div'>, 'div'>((props, ref) => {
  const {header} = useFormSectionStyleConfig();
  return <ChakraDiv sx={header} {...props} ref={ref} />;
});
